(function(){
  var root=document.getElementById('venora-pdp'); if(!root) return;
  var cfgEl=document.getElementById('venora-config'); if(!cfgEl) return;
  var cfg=JSON.parse(cfgEl.textContent);
  var variants=cfg.variants, selected=cfg.selected.slice();

  function el(id){ return document.getElementById(id); }
  var ctaEl=el('venora-cta');
  var CTA_LABEL=(ctaEl?ctaEl.textContent:'').trim()||'Agregar al carrito';
  var PER=(cfg.perPairLabel||'por par');

  // Etiquetas de talla mas cortas
  Array.prototype.forEach.call(root.querySelectorAll('.vopt .vsub'),function(s){
    s.textContent=s.textContent.replace(/pantorrilla\s*/i,'').trim();
  });

  // ---------- titulo en una sola linea ----------
  var h1=root.querySelector('h1');
  function fitTitle(){
    if(!h1) return;
    h1.style.fontSize='';
    var size=parseFloat(window.getComputedStyle(h1).fontSize)||24;
    var guard=0;
    while(h1.scrollWidth>h1.clientWidth+1 && size>12 && guard<90){
      size-=0.5; h1.style.fontSize=size+'px'; guard++;
    }
  }
  fitTitle();
  window.addEventListener('resize',fitTitle,{passive:true});
  if(document.fonts && document.fonts.ready){ document.fonts.ready.then(fitTitle); }

  // ---------- galeria deslizable ----------
  (function(){
    var gal=root.querySelector('.vgal'); if(!gal) return;
    var mainEl=gal.querySelector('.vgal-main'); if(!mainEl) return;
    var stripEl=gal.querySelector('.vgal-strip');
    var nodes=[mainEl].concat(stripEl?Array.prototype.slice.call(stripEl.children):[]);
    if(nodes.length<2) return;

    function reWidth(u,w){
      if(!u) return u;
      if(/[?&]width=\d+/.test(u)) return u.replace(/([?&])width=\d+/,'$1width='+w);
      return u+(u.indexOf('?')>-1?'&':'?')+'width='+w;
    }
    function buildImg(base,alt,sizes,eager){
      var im=document.createElement('img');
      im.src=reWidth(base,1400);
      im.srcset=[400,600,800,1000,1200,1600].map(function(w){ return reWidth(base,w)+' '+w+'w'; }).join(', ');
      im.sizes=sizes;
      im.alt=alt||'';
      im.decoding='async';
      im.loading=eager?'eager':'lazy';
      return im;
    }

    var wrap=document.createElement('div'); wrap.className='vgal-wrap';
    var track=document.createElement('div'); track.className='vgal-track'; track.id='venora-gal';
    var thumbs=document.createElement('div'); thumbs.className='vgal-strip'; thumbs.id='venora-thumbs';

    nodes.forEach(function(node,i){
      var img=node.querySelector?node.querySelector('img'):null;
      var slide=document.createElement('div'); slide.className='vgal-slide';
      var th=document.createElement('button'); th.type='button'; th.className='vgal-th';
      th.setAttribute('data-i',i);
      th.setAttribute('aria-label','Foto '+(i+1));
      th.setAttribute('aria-current', i===0?'true':'false');
      if(img){
        var base=img.currentSrc||img.src||'';
        slide.appendChild(buildImg(base,img.alt,'(min-width:900px) 46vw, 100vw',i===0));
        th.appendChild(buildImg(base,'','120px',false));
      } else {
        slide.className+=' vph'; slide.innerHTML=node.innerHTML;
        th.className+=' vph'; th.innerHTML=node.innerHTML;
      }
      track.appendChild(slide);
      thumbs.appendChild(th);
    });

    var prev=document.createElement('button');
    prev.type='button'; prev.className='vgal-nav vgal-nav--prev';
    prev.setAttribute('aria-label','Foto anterior'); prev.innerHTML='&#8249;';
    var next=document.createElement('button');
    next.type='button'; next.className='vgal-nav vgal-nav--next';
    next.setAttribute('aria-label','Foto siguiente'); next.innerHTML='&#8250;';

    wrap.appendChild(track); wrap.appendChild(prev); wrap.appendChild(next);
    gal.innerHTML=''; gal.appendChild(wrap); gal.appendChild(thumbs);

    var tbs=Array.prototype.slice.call(thumbs.children);
    function activeIndex(){ return Math.round(track.scrollLeft/Math.max(1,track.clientWidth)); }
    function goTo(i){
      if(i<0) i=0;
      if(i>tbs.length-1) i=tbs.length-1;
      track.scrollTo({left:i*track.clientWidth,behavior:'smooth'});
    }
    function sync(){
      var i=activeIndex();
      tbs.forEach(function(b,n){ b.setAttribute('aria-current', n===i?'true':'false'); });
      var b=tbs[i];
      if(b){
        var want=b.offsetLeft-(thumbs.clientWidth-b.clientWidth)/2;
        if(want<0) want=0;
        thumbs.scrollTo({left:want,behavior:'smooth'});
      }
    }
    thumbs.addEventListener('click',function(e){
      var b=e.target.closest('.vgal-th'); if(!b) return;
      goTo(parseInt(b.getAttribute('data-i'),10)||0);
    });
    prev.addEventListener('click',function(){ goTo(activeIndex()-1); });
    next.addEventListener('click',function(){ goTo(activeIndex()+1); });
    var gticking=false;
    track.addEventListener('scroll',function(){
      if(gticking) return; gticking=true;
      window.requestAnimationFrame(function(){ gticking=false; sync(); });
    },{passive:true});
  })();

  function money(n){ return '$'+Math.round(n).toLocaleString('es-MX'); }
  function current(){ return variants.filter(function(v){ return selected.every(function(s,i){ return v.options[i]===s; }); })[0]; }
  function availableFor(index,value){
    return variants.some(function(v){
      if(v.options[index]!==value) return false;
      return selected.every(function(s,i){ return i===index || v.options[i]===s; }) && v.available;
    });
  }

  // ---------- packs ----------
  var packsEl=el('venora-packs');
  var packs=packsEl ? Array.prototype.slice.call(packsEl.querySelectorAll('.vb')) : [];
  var unitPrice=0;
  packs.forEach(function(p){
    var u=parseInt(p.dataset.units,10)||1;
    var pr=parseFloat(String(p.dataset.price).replace(/[^0-9.]/g,''))||0;
    if(u===1 && pr>0) unitPrice=pr;
  });
  if(!unitPrice && packs.length){
    var f=packs[0];
    unitPrice=(parseFloat(String(f.dataset.price).replace(/[^0-9.]/g,''))||0)/(parseInt(f.dataset.units,10)||1);
  }
  function activePack(){
    return packs.filter(function(p){ return p.getAttribute('aria-pressed')==='true'; })[0] || packs[0];
  }
  function paintPacks(){
    packs.forEach(function(p){
      var u=parseInt(p.dataset.units,10)||1;
      var pr=parseFloat(String(p.dataset.price).replace(/[^0-9.]/g,''))||0;
      var pEl=p.querySelector('[data-bprice]'); if(pEl) pEl.textContent=money(pr);
      var wEl=p.querySelector('[data-bwas]');
      if(wEl){
        var full=unitPrice*u;
        if(full>pr+1){ wEl.textContent=money(full); wEl.hidden=false; }
        else { wEl.textContent=''; wEl.hidden=true; }
      }
      var uEl=p.querySelector('[data-bunit]');
      if(uEl) uEl.textContent=u>1 ? (money(pr/u)+' '+PER) : '';
    });
  }

  function paint(){
    var v=current();
    var pack=activePack();
    var units=pack?(parseInt(pack.dataset.units,10)||1):1;
    var total=pack?(parseFloat(String(pack.dataset.price).replace(/[^0-9.]/g,''))||0):unitPrice;

    if(el('venora-price')) el('venora-price').textContent=money(total);
    var wasEl=el('venora-was');
    if(wasEl){
      var full=unitPrice*units;
      if(cfg.showWas && full>total+1){ wasEl.textContent=money(full); wasEl.hidden=false; }
      else { wasEl.textContent=''; wasEl.hidden=true; }
    }
    if(el('venora-per')) el('venora-per').textContent=units>1?(money(total/units)+' '+PER):'';
    if(el('venora-sticky-price')) el('venora-sticky-price').textContent=money(total);
    if(el('venora-qty')) el('venora-qty').value=units;

    if(ctaEl){
      if(v&&v.available){ el('venora-variant-id').value=v.id; ctaEl.disabled=false; ctaEl.textContent=CTA_LABEL; }
      else { ctaEl.disabled=true; ctaEl.textContent=v?'Agotada en esta combinacion':'Elige talla y color'; }
    }

    Array.prototype.forEach.call(root.querySelectorAll('.vopt'),function(b){
      var idx=+b.dataset.index;
      b.setAttribute('aria-pressed', selected[idx]===b.dataset.value?'true':'false');
      b.dataset.unavailable = availableFor(idx,b.dataset.value)?'false':'true';
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-pick-for]'),function(s){
      s.textContent=selected[+s.dataset.pickFor]||'';
    });
  }

  Array.prototype.forEach.call(root.querySelectorAll('.vopts'),function(group){
    group.addEventListener('click',function(e){
      var b=e.target.closest('.vopt'); if(!b) return;
      selected[+b.dataset.index]=b.dataset.value; paint();
    });
  });

  if(packsEl) packsEl.addEventListener('click',function(e){
    var p=e.target.closest('.vb'); if(!p) return;
    packs.forEach(function(x){ x.setAttribute('aria-pressed','false'); });
    p.setAttribute('aria-pressed','true');
    paint();
  });

  // ---------- guia de tallas ----------
  var gbtn=el('venora-guide-btn'), gdlg=el('venora-guide-dlg');
  if(gbtn && gdlg){
    gbtn.addEventListener('click',function(){
      if(typeof gdlg.showModal==='function') gdlg.showModal();
      else gdlg.setAttribute('open','');
    });
    var closeDlg=function(){
      if(typeof gdlg.close==='function') gdlg.close();
      else gdlg.removeAttribute('open');
    };
    var gx=gdlg.querySelector('.vguide-x');
    if(gx) gx.addEventListener('click',closeDlg);
    gdlg.addEventListener('click',function(e){
      if(!e.target.closest('.vguide-dlg__in')) closeDlg();
    });
  }

  // ---------- barra fija: solo tras pasar el boton ----------
  var sticky=el('venora-sticky');
  if(sticky && ctaEl){
    var ticking=false;
    var updateSticky=function(){
      ticking=false;
      var r=ctaEl.getBoundingClientRect();
      sticky.classList.toggle('on', r.bottom < 0);
    };
    var onScroll=function(){
      if(ticking) return;
      ticking=true;
      window.requestAnimationFrame(updateSticky);
    };
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onScroll,{passive:true});
    updateSticky();
  }
  var stickyCta=el('venora-sticky-cta');
  if(stickyCta && ctaEl) stickyCta.addEventListener('click',function(){ ctaEl.click(); });

  paintPacks();
  paint();
})();
